<template>
  <div>
    <h5 style="margin: 20px;">
      You can add new support requests by clicking on ADD ITEM, and view the status of existing support requests in the table below.
    </h5>
    <server-table-component table="sys_supportreq" schema="sch_sys_supportreq"></server-table-component>
  </div>
</template>
<script>
import { sync } from "vuex-pathify"
export default {
  computed: {
    supportreq: sync('misc/supportreq')
  }
}
</script>